module.exports = __webpack_public_path__ + "static/img/2.660c202f.png";